'use client';

import { useEffect } from 'react';
import { usePermission } from '@/hooks/usePermission';
import { setSentryUser } from '@/lib/sentry-user';

/**
 * SentryUserProvider component that sets user context for Sentry error tracking.
 * This component should be placed high in the component tree to ensure user context
 * is available for all Sentry events.
 */
export function SentryUserProvider({
    children,
}: {
    children: React.ReactNode;
}) {
    const { userDetails, isLoading } = usePermission();

    useEffect(() => {
        if (!isLoading) {
            if (userDetails) {
                // Set user context for Sentry
                setSentryUser({
                    id: userDetails.id,
                    email: userDetails.email,
                    username: userDetails.name,
                    // Add role information as additional context
                    role: userDetails.role || undefined,
                });
            } else {
                // Clear user context when no user is logged in
                setSentryUser(null);
            }
        }
    }, [userDetails, isLoading]);

    return <>{children}</>;
}
